import { get } from 'lodash'

// A reload has nothing but the Hydra session to rebuild the checkout form from, and the session
// answers `password: ""` for every enroll session — it never stores one. Copying that back would wipe
// what the customer typed on the way to the payment page, so these keys are the ones a restore has to
// leave alone. They are also why a guest who reloads has to pass through the form again.
export const MEMORY_ONLY_FORM_KEYS = ['password', 'password1', 'password2', 'confirm_password']

// The session stores the shipping method as a code (`standard_shipping`) while the form holds the
// display text it writes itself ("Standard shipping" / "شحن قياسي"), so restoring it would put the raw
// code in front of the customer.
const NOT_RESTORED_FORMAT_KEYS = ['shipping_method']

// Pairs the old code special-cased by hand. Kept explicit so a country class without a
// mapFormKeyToFormatKey still restores them.
const LEGACY_FORMAT_TO_FORM = { zip: 'zip_code', address: 'street_address' }

// The form and the format speak different key names — `mapFormKeyToFormatKey` on the country instance
// is that dictionary. Reading it backwards is what lets a reload put `detail_page.city` back into the
// `city_selection` select; without it the chained address selects (Town/City, Area, Province) came
// back empty on every reload even though the session held their values.
export const formKeyByFormatKey = instance =>
    Object.entries(get(instance, 'mapFormKeyToFormatKey', {}) || {}).reduce(
        (acc, [formKey, formatKey]) => (NOT_RESTORED_FORMAT_KEYS.includes(formatKey) ? acc : { ...acc, [formatKey]: formKey }),
        { ...LEGACY_FORMAT_TO_FORM }
    )

// Writes the session values onto the form inputs in place, which is what the callers already hold.
export const applySessionToForm = (inputs, detailPage = {}, formKeyMap = {}) => {
    const list = Array.isArray(inputs) ? inputs : []
    const sessionKeys = Object.keys(detailPage || {})

    list.forEach(input => {
        if (MEMORY_ONLY_FORM_KEYS.includes(input.key)) {
            return
        }

        const sessionKey = sessionKeys.find(
            key => key === input.key || `${key}`.toLowerCase() === `${input.key}`.toLowerCase() || formKeyMap[key] === input.key
        )

        if (sessionKey !== undefined) {
            input.value = detailPage[sessionKey]
        }
    })

    return list
}
